import axios from 'axios'
import { API_URL, getAuthHeader } from '@/services/api.service.js'
import { logger } from '@/utils/logger'

export async function updateInvitations({ boardId, recipientEmails, patch }) {
  try {
    const ret = await axios.post(
      `${await API_URL()}/invitations/update/${boardId}`,
      { data: { patch, recipientEmails } },
      { headers: { ...(await getAuthHeader()) } }
    )

    if (ret.status === 200 || ret.status === 204) {
      return ret.data
    } else throw new Error(ret.statusText)
  } catch (error) {
    logger.info(error.message)
    return null
  }
}

export async function addInvitations({ boardId, invitations }) {
  try {
    const ret = await axios.post(
      `${await API_URL()}/invitations/${boardId}`,
      { data: { invitations } },
      { headers: { ...(await getAuthHeader()) } }
    )

    if (ret.status === 200 || ret.status === 201) {
      return ret.data
    } else throw new Error(ret.statusText)
  } catch (error) {
    logger.info(error.message)
    return null
  }
}

export async function getPendingInvitationsForEmail({ email, invitationAccepted = false }) {
  try {
    const ret = await axios.post(
      `${await API_URL()}/invitations/email`,
      { data: { email, invitationAccepted } },
      { headers: { ...(await getAuthHeader()) } }
    )

    if (ret.status === 200) {
      return ret.data
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.info(error.message)
    return []
  }
}

export async function getPendingInvitationsForBoard({ boardId }) {
  try {
    const ret = await axios.get(`${await API_URL()}/invitations/board/${boardId}/false`, {
      headers: { ...(await getAuthHeader()) }
    })

    if (ret.status === 200) {
      return ret.data
    } else throw new Error(ret.statusText)
  } catch (error) {
    logger.info(error.message)
    return null
  }
}

export async function getInvitationLogs({ boardId, limit = 50, offset = 0 }) {
  try {
    const ret = await axios.get(`${await API_URL()}/invitations/${boardId}/logs`, {
      params: { limit, offset },
      headers: { ...(await getAuthHeader()) }
    })

    if (ret.status === 200) {
      const defaultPagination = { limit, offset, total: 0 }
      return {
        invitations: ret.data?.invitations || [],
        count: ret.data?.count ?? ret.data?.pagination?.total ?? 0,
        pagination: ret.data?.pagination || defaultPagination
      }
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.info(error.message)
    return { invitations: [], count: 0, pagination: { limit, offset, total: 0 } }
  }
}

export async function acceptInvitation({ id, boardId }) {
  try {
    const ret = await axios.post(
      `${await API_URL()}/invitations/${id}/accept`,
      {
        data: {
          boardId
        }
      },
      { headers: { ...(await getAuthHeader()) } }
    )

    if (ret.status === 200) {
      return ret.data
    } else throw new Error(ret.statusText)
  } catch (error) {
    logger.info(error.message)
    return null
  }
}

export async function acceptInvitationForOutsiders({ email }) {
  try {
    const ret = await axios.post(
      `${await API_URL()}/invitations/outsider/accept`,
      { data: { email } },
      { headers: { ...(await getAuthHeader()) } }
    )

    if (ret.status === 200) {
      return ret.data
    } else throw new Error(ret.statusText)
  } catch (error) {
    logger.info(error.message)
    return null
  }
}

export async function sendInvites(boardId, invitations) {
  try {
    const ret = await axios.post(
      `${await API_URL()}/invitations/${boardId}/send-invite`,
      { data: { invitations } },
      { headers: { ...(await getAuthHeader()) } }
    )

    if (ret.status === 200) {
      return ret.data
    }

    throw new Error(ret.statusText)
  } catch (error) {
    logger.info(error.message)
    return null
  }
}
